import {
  useImage
} from "./chunk-WBMNQIIL.esm.js";
import {
  forwardRef
} from "./chunk-QPGVD7NS.esm.js";

// src/image.tsx
import { cloneElement } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Image = forwardRef((props, ref) => {
  const {
    Component,
    domRef,
    classNames,
    isBlurred,
    isZoomed,
    fallbackSrc,
    removeWrapper,
    disableSkeleton,
    showResponsiveImage,
    responsiveImageSourceConfig,
    getImgProps,
    getPictureProps,
    getWrapperProps,
    getBlurredImgProps
  } = useImage({
    ...props,
    ref
  });
  let img = null;
  if (showResponsiveImage) {
    img = /* @__PURE__ */ jsxs("picture", { ...getPictureProps(), children: [
      responsiveImageSourceConfig == null ? void 0 : responsiveImageSourceConfig.map((item) => /* @__PURE__ */ jsx(
        "source",
        {
          media: item.media,
          srcSet: item.srcSet,
          type: item.type
        },
        item.media + item.srcSet
      )),
      /* @__PURE__ */ jsx(Component, { ref: domRef, decoding: "async", ...getImgProps() })
    ] });
  } else {
    img = /* @__PURE__ */ jsx(Component, { ref: domRef, ...getImgProps() });
  }
  if (removeWrapper) {
    return img;
  }
  const zoomed = /* @__PURE__ */ jsx("div", { className: classNames == null ? void 0 : classNames.zoomedWrapper, children: img });
  if (isBlurred) {
    return /* @__PURE__ */ jsxs("div", { ...getWrapperProps(), children: [
      isZoomed ? zoomed : img,
      cloneElement(img, getBlurredImgProps())
    ] });
  }
  if (isZoomed || !disableSkeleton || fallbackSrc) {
    return /* @__PURE__ */ jsxs("div", { ...getWrapperProps(), children: [
      " ",
      isZoomed ? zoomed : img
    ] });
  }
  return img;
});
Image.displayName = "4f2e.React.Image";
var image_default = Image;

export {
  image_default
};
//# sourceMappingURL=chunk-L7ID46IZ.esm.js.map